/*------Accessibility------ */
export const ENTER = 'Enter';
export const SPACE = ' ';
